import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareReportsOverviewRoute: InvariantJiraRoute = {
	name: 'software-reports',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports',
};
